<template>
  <section class="sidebarSectionClass">
    <div class="sidebarHeading">
      {{ $t('pages.dashboard.components.foundryHealth.sidebar.heading') }}
    </div>
    <div class="sidebarContentUpperDiv">
      <div class="sidebarContent">
        <div class="contentHeading">
          {{ $t('pages.dashboard.components.foundryHealth.sidebar.contentHeading') }}
        </div>
        <div v-for="(item, index) in items" :key="index">
          <div class="contentItem">
            <div class="contentItemUpperDiv" :class="[{ 'challenge-complete': item.taskStatus === 'completed' }]" @click="changeRoute(item)">
              <div class="contentItemInnerDiv">
                <div class="contentItemIcon">
                  <span :class="item.taskIcon">
                  </span>
                </div>
                <div class="contentItemTitle">
                  {{ item.taskName }}
                </div>
              </div>
              <div>
                <span class="circle" :class="['circle', { 'completed': item.taskStatus === 'completed' }]">
                  <TickIcon v-if="item.taskStatus === 'completed'" />
                  <ArrowIcon v-else />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="completeChallengeCount">
        {{completedChallenge +'/'+ items.length}}
      </div>
    </div>
    <div class="sidebarDescriptionSection">
      <div class="sidebarDescriptionHeading">
        {{ $t('pages.dashboard.components.foundryHealth.sidebar.descHeading') }}
      </div>
      <div class="sidebarDescription">
        {{ $t('pages.dashboard.components.foundryHealth.sidebar.desc') }}
      </div>
      <div>
        <a class="learnMoreBtn" target="_blank" rel="noopener" :href="$t('pages.dashboard.components.foundryHealth.sidebar.learnLink')">
          {{ $t('pages.dashboard.components.foundryHealth.sidebar.learnBtn') }}
        </a>
      </div>
    </div>
  </section>
  <common-popup v-if="showPermissionNeededPopup" @popup:crossBtnClick="closePermissionNeededPopup" @popup:btn1Click="closePermissionNeededPopup" 
      :modalHeading="$t('pages.profile.foundry_profile.permission_denied.title')" 
      :modalContent="$t('pages.profile.foundry_profile.permission_denied.description')" 
      :modalButton1="$t('pages.profile.foundry_profile.permission_denied.btn1')" 
      :showButton2="false"
      :customBtn1Class="true"
      id="permission-needed-modal" data-qa-id="permission-needed-modal" />
</template>
<script src="./script.js"></script>
<style lang="scss" src="./stylesheets/index.scss" />